export default __webpack_public_path__ + "static/media/Q19_4_resized.ca6b7938.jpg";